module.exports = __webpack_public_path__ + "img/fantasy_2.85e5e5bc.png";